module.exports = __webpack_public_path__ + "static/media/gts_corporate_website.04829355.png";